import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useExperiment } from '@web/experiments';
import {
  BaseHeader,
  LeftMenuLinks,
  CenterMenuLinks,
  DiscountBanner,
  UserMenuLinks,
} from '@web/molecules';
import { useSessionCustomer } from '../customer';

export const MarketingHeader = ({
  links,
  logoUrl,
  logoSrText,
  sticky = true,
  hidePromoBar,
  discountBannerProps,
  ctaButton,
}) => {
  const { isActive } = useSessionCustomer();
  const { value: experimentValue = 'control' } = useExperiment(
    ctaButton?.testName || null,
  );

  const experimentCtaButton = useMemo(() => {
    if (ctaButton?.testName && ctaButton?.component === 'flagship_ab_test') {
      const experimentVariation = ctaButton?.variants.find(
        variant => variant.variant_name === experimentValue,
      );
      const variantBlock = experimentVariation?.blocks?.[0];

      return {
        mobileCTAText:
          variantBlock?.mobile_cta_text || ctaButton?.mobile_cta_text,
        desktopCTAText:
          variantBlock?.desktop_cta_text || ctaButton?.desktop_cta_text,
        ctaTarget: variantBlock?.cta_target?.url || ctaButton?.cta_target?.url,
        ctaVariant: variantBlock?.cta_variant || ctaButton?.cta_variant,
      };
    }

    return {
      mobileCTAText: ctaButton?.mobileCTAText,
      desktopCTAText: ctaButton?.desktopCTAText,
      ctaTarget: ctaButton?.ctaTarget?.url || ctaButton?.ctaTarget,
      ctaVariant: ctaButton?.ctaVariant,
    };
  }, [ctaButton, experimentValue]);

  const topHeaderSegment = !hidePromoBar && !isActive && (
    <DiscountBanner {...discountBannerProps} />
  );
  const rightNavSegment = <UserMenuLinks {...experimentCtaButton} />;
  const leftNavSegment = <LeftMenuLinks links={links} />;
  const centerNavSegment = <CenterMenuLinks links={links} />;

  return (
    <BaseHeader
      logoUrl={logoUrl}
      logoSrText={logoSrText}
      topSegment={topHeaderSegment}
      rightSegment={rightNavSegment}
      centerSegment={centerNavSegment}
      leftSegment={leftNavSegment}
      sticky={sticky}
      stickyBanner={false}
    />
  );
};

MarketingHeader.displayName = 'MarketingHeader';

MarketingHeader.propTypes = {
  links: PropTypes.array.isRequired,
  logoUrl: PropTypes.string,
  logoSrText: PropTypes.string,
  sticky: PropTypes.bool,
  discountBannerProps: PropTypes.object,
  hidePromoBar: PropTypes.bool,
  ctaButton: PropTypes.object,
  testName: PropTypes.string,
};
